import Button from "@material-ui/core/Button";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  Button,
  Playground,
  React
};